export const en = {
  whatsNew: {
    title: "What's new",
    intro: "Here's what's new in Vamos Tamos.",
    teamsTitle: "Save your teams",
    teamsBody: "Save a roster with a name and 4-digit PIN, then reload it anytime.",
    languagesTitle: "More languages",
    languagesBody: "Vamos Tamos now speaks 6 languages, including German and Indonesian.",
    cta: "Got it",
    badge: "New",
  },
  common: {
    loading: "Loading...",
    points: "pts",
    court: "Court",
    team: "Team",
    player: "Player",
    rank: "Rank",
    score: "Score",
    share: "Share results",
    linkCopied: "Link copied to clipboard",
    shareFailed: "Tournament is too large to share via URL. Try with fewer players.",
    and: "and",
    close: "Close",
    save: "Save",
    cancel: "Cancel",
    back: "Back",
    yes: "Yes, Remove",
    no: "No, Go Back",
    editable: "Editable",
    buyMeCoffee: "Buy me a coffee",
  },
  results: {
    leastGames: "Least games",
    leastGamesTooltip: "Least games played",
  },
  tournament: {
    new: "Americano or Mexicano?",
    create: "Create Tournament",
    nameRequired: "Tournament name is required",
    tournamentName: "Tournament name",
    round: "Round",
    completeRound: "Complete Round",
    completingRound: "Completing...",
    nextRoundReady: "Round #{round} is ready",
    endTournament: "End Tournament",
    formatRequired: "Please select Americano or Mexicano",
    enterScores: "Please enter all scores before completing the round",
    bench: "Players on Bench",
    finalResults: "tournament",
    finished: "Tournament Finished",
    winner: "Winner",
    winners: "Winners",
    with: "with",
    points: "points",
    summary: "Tournament completed in {rounds} rounds with {players} players on {courts} courts",
    confirmEnd: "Are you sure? Scores from this round will not be included in total score",
    yes: "Yes",
    no: "No",
    newTournament: 'Start new Tournament',
    playedMatches: 'Played',
    pairingComplete: "Pairing Complete",
    roundSaved: "Round #{round} saved",
    allPlayersPaired: "Tournament completed!",
    continueWithNewPairs: "Continue Tournament",
    viewResults: "View Results",
    tournamentEnded: "Tournament Ended",
    roundSettings: "Round settings",
    pointsModeLabel: "Points-based to {points}",
    timeModeLabel: "Time-based, {minutes} min",
    timer: "Timer: {time}",
    timerStatus: "Round timer",
    timeUp: "Time is up! Please finish the round and enter scores.",
    editRoster: "Edit Roster",
    editRosterTitle: "Edit Players & Courts",
    addPlayer: "Add Player",
    removePlayer: "Remove",
    reactivatePlayer: "Reactivate",
    inactivePlayers: "Inactive Players",
    applyChanges: "Apply Changes",
    rosterWarning: "Current round will be regenerated and scores reset",
    rosterWarningTitle: "Applying changes will restart this round",
    rosterWarningRegenerate: "Teams for the current round will be reshuffled and regenerated.",
    rosterWarningScores: "Any scores already entered for this round will be cleared.",
    rosterWarningNewPlayers: "New players join immediately and are added to this round.",
    rosterWarningSafe: "Scores from previous, completed rounds are kept.",
    minPlayersWarning: "Need at least 4 active players",
    courtsReduced: "Courts reduced to {courts} (not enough active players)",
    playerInactive: "Inactive",
    mixedPairsWarning: "Mixed pairs require equal male and female players",
    arrangeFirstRound: "Arrange First Round",
    arrangeFirstRoundTitle: "Arrange First Round",
    arrangeFirstRoundHelp: "Tap or click one player card, then tap another slot to swap them. Use the bench row to swap players in and out. This works the same on mobile and desktop.",
    resetFirstRound: "Reset Changes",
    firstRoundUpdated: "First round updated",
    manualFirstRoundInvalid: "Each active player must appear exactly once in the first round setup.",
    manualFirstRoundMixedPairs: "Mixed pairs require one male and one female on each team.",
    manualFirstRoundBenchSlot: "Bench slot {number}",
    removePlayerTitle: "Remove Player",
    removePlayerMessage: "How do you want to remove {player}?",
    removePlayerExplanation: "Make Inactive: Player stays on leaderboard but won't be assigned to games. Remove Completely: Player is deleted from the tournament entirely.",
    makeInactive: "Make Inactive (keep on leaderboard)",
    removeCompletely: "Remove Completely (delete from tournament)",
    removePlayerFinalTitle: "Are you sure?",
    removePlayerFinalMessage: "This will permanently delete {player} and all their scores from the tournament. This cannot be undone."
  },
  tvMode: {
    subtitle: "Cast this page to a TV to show the live leaderboard and courts",
    round: "Round {round}",
    leaderboard: "Leaderboard",
    lastRound: "Last round",
    onCourt: "On court now",
    noGames: "No active games yet",
    bench: "Waiting this round",
    missingStateTitle: "TV mode needs a tournament link",
    missingStateBody: "Open TV mode from an active or finished tournament to mirror its data on screen.",
    openButton: "Open TV mode",
  },
  theme: {
    switchToDark: 'Switch to dark mode',
    switchToLight: 'Switch to light mode',
    toggleLabel: 'Toggle color mode',
  },
  playerSetup: {
    title: "Who's playing?",
    addPlayer: "Add Player",
    playerName: "Player",
    playerRequired: "Player name is required",
    formatTitle: "Tournament style",
    formatAmericano: "Americano game",
    formatMexicano: "Mexicano game",
    courtsTitle: "Number of Courts",
    court: "Court",
    courts: "Courts",
    startTournament: "Start Tournament",
    loadTeam: "Load team",
    saveTeam: "Save team",
    loadTeamTitle: "Load a saved team",
    saveTeamTitle: "Save this team",
    teamCode: "Team name",
    loadTeamHint: "Enter a memorable team name to reuse its player list.",
    saveTeamHint: "Give this player list a memorable name so you can reuse it next time.",
    savedTeamsTitle: "Your saved teams",
    noSavedTeams: "No saved teams on this device yet.",
    teamNameRequired: "Please enter a team name",
    noPlayersToSave: "Add at least one player name before saving",
    teamNotFound: "No saved team found with that name",
    teamSaved: "Team saved",
    teamSaveFailed: "Unable to save the team. Please try again.",
    teamSavedLocally: "Team saved on this device. Sharing is not confirmed yet.",
    teamLoaded: "Team loaded",
    updatingTeam: "Saving will update your team \"{name}\".",
    teamNameTaken: "That name is already taken. Tap the suggestion or enter another.",
    suggestionLabel: "Suggested name",
    load: "Load",
    createTeam: "Create team",
    pinFourDigits: "PIN (4 digits)",
    pinEnterPrompt: "Enter the team's 4-digit PIN.",
    pinCreateWarning: "You'll need this PIN to load the team later. It can't be recovered \u2014 if you forget it, you'll have to create a new team.",
    pinInvalid: "PIN must be 4 digits.",
    pinIncorrect: "Incorrect PIN. PINs can't be recovered \u2014 create a new team if forgotten.",
    notEnoughPlayers: "Need at least {count} players for {courts} courts",
    duplicateName: "Duplicate name",
    roundTypeTitle: "Round type",
    roundTypePoints: "Points",
    roundTypeTime: "Time based",
    targetPoints: "Points to play to",
    roundMinutes: "Minutes per round",
    timerHint: "A whistle and banner will trigger when the timer hits 0.",
    mixedPairsLabel: "Mixed pairs (M+F teams)",
    mexicanoPairingTitle: "Mexicano pairing",
    mexicanoPairingHint: "Choose how each court of four is split into teams.",
    mexicanoPairingStandard: "Option 1: #1 + #3 vs #2 + #4",
    mexicanoPairingStandardDescription: "Pairs the 1st-ranked player with the 3rd, and the 2nd with the 4th on each court.",
    mexicanoPairingAlternate: "Option 2: #1 + #4 vs #2 + #3",
    mexicanoPairingAlternateDescription: "Pairs the top player with the 4th-ranked player, and the middle two together on each court.",
    gender: "Gender",
    male: "Male",
    female: "Female",
    genderBalance: "Mixed pairs require an equal number of male and female players."
  },
  rules: {
    titleAmericano: 'How Americano Works',
    titleMexicano: 'How Mexicano Works',
    teamSetupTitle: 'Team Setup',
    teamSetupAmericano: 'Players are randomly assigned to teams before each round to ensure different team combinations and opponents.',
    teamPattern13v24: '#1+#3 play vs #2+#4',
    teamPattern14v23: '#1+#4 play vs #2+#3',
    teamSetupMexicano: 'Pairings follow the live leaderboard. Players are grouped into 4 by rank (top 4, next 4, etc). On each court: {pattern}. The next court follows the same pattern. This makes strong players face strong players and weaker players face weaker players — the goal is a high individual score, not a single winning couple.',
    scoringSystemTitle: 'Scoring System',
    scoringSystem: 'Each round is played to a set number of points or for a set time. Points are assigned individually – for example, if a team wins 13–8, each player on the winning team gets 13 points, and the losing players get 8.',
    winnerTitle: 'Winner',
    winner: 'The player with the most points overall wins and gets applause from the others. :)',
    faqTitle: 'Frequently asked questions',
    faqFormatsQ: "What's the difference between Americano and Mexicano?",
    faqFormatsA: 'In Americano, players are randomly paired each round so everyone partners with and against everyone. In Mexicano, pairings follow the live leaderboard, matching players of similar rank.',
    faqSportsQ: 'Can I use it for sports other than padel?',
    faqSportsA: 'Yes. Although built for padel, the Americano and Mexicano formats work for pickleball, tennis, table tennis, badminton and any game scored by points.',
    faqFreeQ: 'Is it free and do I need an account?',
    faqFreeA: "It's completely free with no sign-up. Tournaments run in your browser and work offline.",
    faqPlayersQ: 'How many players and courts can I use?',
    faqPlayersA: 'Any number of players across one or more courts. The app rotates players automatically each round.'
  },
  privacy: {
    title: "Privacy Policy",
    lastUpdated: "Last updated",
    dataCollection: "Data Collection",
    dataCollectionText: "Vamos Tamos does not collect or store any personal data. All tournament data stays on your device.",
    localStorage: "Local Storage",
    localStorageText: "Tournament data is stored locally in your browser's localStorage to maintain game state. You can clear this data anytime through your browser settings.",
    cookies: "Cookies",
    cookiesText: "This app does not use cookies for tracking. Only essential browser storage (localStorage) is used for tournament functionality.",
    thirdParty: "Third-Party Services",
    thirdPartyText: "We use Vercel Web Analytics to collect anonymous, aggregated usage data (page views, visitor counts). This data is privacy-focused and does not track individual users, use cookies, or collect personal information. Learn more at vercel.com/analytics.",
    rights: "Your Rights (GDPR/CCPA)",
    rightsText: "Since no personal data is collected or processed, you maintain full control of your data. You can delete all locally stored tournament data by clearing your browser's localStorage.",
    contact: "Contact",
    contactText: "For privacy questions, contact: the.adnan@gmail.com",
    backHome: "Back to Home"
  }
};
